import { BasePrescriptionTemplate } from './BasePrescriptionTemplate';
import type { PrescriptionPrintTemplateProps } from '../types';

const extractInternalMedicineSummary = (specialtyData: Record<string, unknown> | null): string | null => {
  if (!specialtyData) return null;

  const internalMedicine = specialtyData.internal_medicine;
  if (!internalMedicine || typeof internalMedicine !== 'object') return null;

  const riskLevel = (internalMedicine as { cardiovascular_risk?: unknown }).cardiovascular_risk;
  if (typeof riskLevel !== 'string' || riskLevel.trim() === '') return null;

  return `Medicina interna: riesgo cardiovascular ${riskLevel.trim()}.`;
};

export function InternalMedicinePrescriptionTemplate(props: PrescriptionPrintTemplateProps) {
  const internalMedicineSummary = extractInternalMedicineSummary(props.specialtyData);

  if (!internalMedicineSummary) {
    return <BasePrescriptionTemplate {...props} />;
  }

  const mergedRecommendations = props.consultation.general_recommendations
    ? `${internalMedicineSummary}\n${props.consultation.general_recommendations}`
    : internalMedicineSummary;

  return (
    <BasePrescriptionTemplate
      {...props}
      consultation={{
        ...props.consultation,
        general_recommendations: mergedRecommendations,
      }}
    />
  );
}
